import { JSX } from 'react';
import {
  ComponentParams,
  ComponentRendering,
  Placeholder,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { LeftNavLayout } from '@ahc-digital/component-library';

interface GeneralLeftNavSublayoutProps {
  rendering?: ComponentRendering & { params?: ComponentParams };
  params?: ComponentParams;
}

export const Default = (props?: GeneralLeftNavSublayoutProps): JSX.Element => {
  const id = props?.params?.RenderingIdentifier;

  if (!props?.rendering) {
    return <></>;
  }

  return (
    <LeftNavLayout
      id={id}
      aboveLeftNavSection={
        <Placeholder name="above-left-nav-section" rendering={props.rendering} />
      }
      breadcrumbsSection={<Placeholder name="breadcrumb-section" rendering={props.rendering} />}
      leftNavLinks={<Placeholder name="left-nav-links" rendering={props.rendering} />}
      leftNavContent={<Placeholder name="left-nav-content" rendering={props.rendering} />}
      belowLeftNavSection={
        <Placeholder name="below-left-nav-section" rendering={props.rendering} />
      }
    />
  );
};
